(function () {
  'use strict';
  var root = document.getElementById('azc');
  if (!root) return;

  var cfgEl = root.querySelector('[data-azc-config]');
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };

  var params = new URLSearchParams(location.search);
  var logged = root.dataset.logged === 'true';
  var customerId = root.dataset.customerId || '';
  // Le serveur (tag du client) fait foi. Le marqueur local ne couvre que les quelques minutes de délai
  // juste après une participation ; passé ce délai il est ignoré et effacé.
  var doneRec = String(store.get('azc_done') || '').split('|');
  var doneLocal = logged && customerId !== '' && doneRec[0] === customerId && (Date.now() - (parseInt(doneRec[1], 10) || 0)) < 600000;
  if (store.get('azc_done') && !doneLocal) store.del('azc_done');
  var done = root.dataset.done === 'true' || doneLocal;
  var isDesign = root.dataset.design === 'true';
  var delay = Math.max(0, parseInt(root.dataset.delay, 10) || 0) * 1000;
  var reshowMs = (parseInt(root.dataset.reshowDays, 10) || 0) * 86400000;
  var dialog = root.querySelector('.azc__dialog');
  var pills = document.querySelectorAll('.azc-pill');
  var lastFocus = null;

  /* ---------- Suivi anonyme du parcours (compteurs agrégés, aucune donnée personnelle) ---------- */
  var trackUrl = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'apps/concours/track';
  var devSuffix = window.innerWidth < 760 ? 'm' : 'd';
  function track(ev) {
    if (isDesign) return;
    try {
      var key = 'azc_t_' + ev;
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (e) { /* stockage indisponible : on compte quand même */ }
    var u = trackUrl + '?e=' + encodeURIComponent(ev) + '&d=' + devSuffix;
    try { if (navigator.sendBeacon && navigator.sendBeacon(u)) return; } catch (e) {}
    try { fetch(u, { method: 'POST', keepalive: true }); } catch (e) {}
  }
  track(onContestPageEarly() ? 'visit_contest_page' : 'visit');
  function onContestPageEarly() { return location.pathname.indexOf('/pages/jeu-concours') === 0; }

  // Aperçu du remplissage de la jauge, uniquement sur un thème non publié.
  var isDraftTheme = window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main';
  var BUYERS_OFFSET = 0; /* participants acheteurs hors inscrits popup, MAJ 03/11/2026 */ var count = cfg.count + BUYERS_OFFSET;
  var liveCountLoaded = false;
  if (isDraftTheme && params.has('azc_count')) { count = parseInt(params.get('azc_count'), 10) || 0; liveCountLoaded = true; }
  // Retour après une participation validée : on affiche la jauge avec « +1 ».
  var joinPrev = null;
  try { var jp = sessionStorage.getItem('azc_join_prev'); if (jp !== null) joinPrev = parseInt(jp, 10); } catch (e) { /* stockage indisponible */ }
  var bumpPending = joinPrev !== null && !isNaN(joinPrev);
  var bumping = false, repaintAfterBump = false;
  if (bumpPending && !liveCountLoaded) count = joinPrev;

  function fmt(n) { return Number(n).toLocaleString('fr-FR'); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  /* ---------- Gauge ---------- */
  function pctFor(n) {
    var t = cfg.tiers, prev = 0, step = 100 / t.length, i;
    if (n <= 0) return 0;
    for (i = 0; i < t.length; i++) {
      if (n < t[i].n) return i * step + ((n - prev) / (t[i].n - prev)) * step;
      prev = t[i].n;
    }
    return 100;
  }

  var lock = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
  var check = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5 9-10"/></svg>';

  function gaugeHTML() {
    var t = cfg.tiers, pct = pctFor(count), next = null, i;
    for (i = 0; i < t.length; i++) { if (count < t[i].n) { next = t[i]; break; } }
    var nextTxt = next
      ? 'Plus que <b>' + fmt(next.n - count) + '</b> pour « ' + esc(next.t) + ' »'
      : 'Tous les paliers sont débloqués !';
    var nodes = '', labels = '', step = 100 / t.length;
    for (i = 0; i < t.length; i++) {
      var reached = count >= t[i].n;
      nodes += '<span class="azc-g__node' + (reached ? ' is-reached' : '') + (i === t.length - 1 ? ' is-final' : '') + '" style="left:' + ((i + 1) * step) + '%">' + (reached ? check : lock) + '</span>';
      labels += '<li class="azc-g__tier' + (reached ? ' is-reached' : '') + '"><b>' + fmt(t[i].n) + '</b><span>' + esc(t[i].t) + '</span></li>';
    }
    return '<div class="azc-g" role="group" aria-label="Progression du jeu concours">' +
      '<div class="azc-g__head"><span class="azc-g__count">' + fmt(count) + '<small>' + esc(cfg.unit) + '</small></span><span class="azc-g__next">' + nextTxt + '</span></div>' +
      '<div class="azc-g__track" role="progressbar" aria-valuemin="0" aria-valuemax="' + t[t.length - 1].n + '" aria-valuenow="' + count + '"><div class="azc-g__fill" style="width:0%" data-pct="' + pct.toFixed(1) + '"></div>' + nodes + '</div>' +
      '<ol class="azc-g__tiers">' + labels + '</ol></div>';
  }

  function fetchLiveCount() {
    fetch('/apps/concours/count', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.ok && typeof data.count === 'number') {
          /* jauge en tickets : valeur issue du metafield shop custom.concours_tickets (pas d'override par le compteur d'inscrits) */
          if (bumpPending && count < joinPrev + 1) count = joinPrev + 1;
          liveCountLoaded = true;
          if (bumping) { repaintAfterBump = true; } else { paintGauges(); runBump(); }
        }
      })
      .catch(function () {});
  }

  function paintGauges() {
    var html = gaugeHTML();
    document.querySelectorAll('[data-azc-gauge], [data-azc-gauge-target]').forEach(function (el) {
      el.innerHTML = html;
      var fill = el.querySelector('.azc-g__fill');
      if (fill) requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.width = fill.dataset.pct + '%'; }); });
    });
  }

  function runBump() {
    if (!bumpPending) return;
    var host = document.getElementById('azc-gauge');
    if (!host) return;
    var el = host.querySelector('.azc-g__count');
    if (!el || !el.firstChild) return;
    bumpPending = false; bumping = true;
    try { sessionStorage.removeItem('azc_join_prev'); } catch (e) { /* ignore */ }
    var from = joinPrev, to = Math.max(count, joinPrev + 1);
    host.scrollIntoView({ behavior: 'smooth', block: 'start' });
    el.firstChild.nodeValue = fmt(from);
    el.classList.add('is-bump');
    var plus = document.createElement('em');
    plus.className = 'azc-g__plus';
    plus.textContent = '+' + (to - from);
    el.appendChild(plus);
    setTimeout(function () { el.firstChild.nodeValue = fmt(to); }, 700);
    setTimeout(function () {
      el.classList.remove('is-bump'); if (plus.parentNode) plus.parentNode.removeChild(plus);
      bumping = false;
      if (repaintAfterBump) { repaintAfterBump = false; paintGauges(); }
    }, 4600);
  }

  /* ---------- Steps / open / close ---------- */
  function go(step) {
    root.dataset.step = step;
    root.querySelectorAll('[data-azc-step]').forEach(function (el) { el.hidden = el.dataset.azcStep !== step; });
  }

  function open(step) {
    if (!step) step = done ? 'done' : (logged ? 'terms' : 'intro');
    if (step === 'terms') track('terms_shown');
    go(step);
    track('popup_open');
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('azc-lock');
    pills.forEach(function (p) { p.hidden = true; });
    paintGauges();
    setTimeout(function () { dialog.focus(); }, 30);
  }

  function close(remember) {
    root.hidden = true;
    document.documentElement.classList.remove('azc-lock');
    if (remember !== false && !done) store.set('azc_dismissed_at', String(Date.now()));
    pills.forEach(function (p) { p.hidden = done; });
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function participate() {
    if (done) return go('done');
    track('participate_click');
    if (logged) { track('terms_shown'); go('terms'); return; }
    store.set('azc_intent', String(Date.now()));
    track('login_shown');
    go('login');
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-azc-close],[data-azc-participate],[data-azc-back]');
    if (!t) return;
    if (t.hasAttribute('data-azc-close')) close();
    else if (t.hasAttribute('data-azc-participate')) participate();
    else if (t.hasAttribute('data-azc-back')) go(t.dataset.azcBack);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-azc-open]');
    if (!t) return;
    e.preventDefault();
    var want = t.dataset.azcOpen;
    track(t.classList.contains('az-cstrip__cta') ? 'open_from_strip' : (t.classList.contains('azc-pill') ? 'open_from_pill' : 'open_from_page'));
    open(want === 'terms' ? (logged && !done ? 'terms' : undefined) : undefined);
    if (want === 'participate') participate();
  });

  /* Login link: mémorise l'intention pour rouvrir l'étape « règlement » au retour */
  var loginLink = root.querySelector('[data-azc-login]');
  if (loginLink) loginLink.addEventListener('click', function () { track('login_click'); store.set('azc_intent', String(Date.now())); });

  /* ---------- Submit (tags + abonnement e-mail via l'App Proxy — pas de formulaire public, pas de captcha) ---------- */
  var form = document.getElementById('azc-form');
  if (form) {
    var submitBtn = form.querySelector('[data-azc-submit]');
    submitBtn.addEventListener('click', function () {
      var errEl = form.querySelector('[data-azc-error]');
      errEl.hidden = true;
      submitBtn.disabled = true; submitBtn.textContent = 'Validation…';
      fetch(form.dataset.azcJoinUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rulesAccepted: true, emailOptin: form.elements.azc_optin.checked }),
      })
        .then(function (res) { return res.json().catch(function () { return {}; }).then(function (data) { return { ok: res.ok && data.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) {
            errEl.textContent = 'Une erreur est survenue. Réessayez dans un instant.';
            errEl.hidden = false; submitBtn.disabled = false; submitBtn.textContent = 'Valider ma participation';
            return;
          }
          track('join_ok');
          var prevCount = count;
          done = true;
          store.set('azc_done', customerId + '|' + Date.now()); store.del('azc_intent');
          document.querySelectorAll('[data-azc-state]').forEach(function (el) { el.hidden = el.dataset.azcState !== 'valid'; });
          document.querySelectorAll('.azc-pill').forEach(function (p) { p.remove(); });
          try { sessionStorage.setItem('azc_join_prev', String(prevCount)); } catch (e) { /* ignore */ }
          if (onContestPage) {
            joinPrev = prevCount; bumpPending = true; count = prevCount + 1;
            close(false);
            paintGauges();
            runBump();
            setTimeout(fetchLiveCount, 900);
          } else {
            location.href = contestPath + '#azc-gauge';
          }
        })
        .catch(function () {
          errEl.textContent = 'Une erreur est survenue. Réessayez dans un instant.';
          errEl.hidden = false; submitBtn.disabled = false; submitBtn.textContent = 'Valider ma participation';
        });
    });
  }

  /* ---------- Boot ---------- */
  paintGauges();
  if (!liveCountLoaded) fetchLiveCount();
  if (bumpPending) setTimeout(function () { if (bumpPending) { count = Math.max(count, joinPrev + 1); paintGauges(); runBump(); } }, 3000);

  function pathOf(url) { try { return new URL(url, location.origin).pathname; } catch (e) { return url; } }
  var contestPath = pathOf(root.dataset.termsUrl || '/pages/jeu-concours');
  var onContestPage = location.pathname === contestPath || location.pathname === contestPath + '/';
  var recentlyDismissed = reshowMs > 0 && (Date.now() - (parseInt(store.get('azc_dismissed_at'), 10) || 0) < reshowMs);
  var intent = parseInt(store.get('azc_intent'), 10) || 0;
  var intentFresh = intent && (Date.now() - intent < 86400000);

  if (logged && !done && intentFresh) {
    track('returned_after_login');
    // Après connexion : la personne avait cliqué sur « Participer », on lui ouvre directement la confirmation (un seul clic).
    store.del('azc_intent');
    setTimeout(function () { open('terms'); }, 500);
  } else if (params.has('concours') || isDesign) {
    setTimeout(function () { open(); }, isDesign ? 300 : 500);
  } else if (!done && !onContestPage && !recentlyDismissed && /^\/(products|collections|cart)(\/|$)/.test(location.pathname)) {
    // Fiches produit / collections : pas d'ouverture à l'arrivée (elle gêne l'achat). On propose à la sortie ou après un long temps de lecture.
    var offered = false;
    function offer(why) {
      if (offered || !root.hidden || done) return;
      try { if (sessionStorage.getItem('azc_offered')) return; sessionStorage.setItem('azc_offered', '1'); } catch (e) {}
      offered = true; track('popup_' + why); open();
    }
    pills.forEach(function (p) { p.hidden = false; });
    setTimeout(function () { offer('dwell'); }, 50000);
    setTimeout(function () {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 8) offer('exit'); });
    }, 8000);
  } else if (!done && !onContestPage && !recentlyDismissed) {
    setTimeout(function () { track('popup_auto'); open(); }, delay);
  } else {
    pills.forEach(function (p) { p.hidden = done; });
  }
})();
